import { NumberFieldUI } from '@axo/form/feature/form-input/NumberField/NumberFieldUI';
import { useTranslation } from '@axo/shared/i18n';
import { useMemo } from 'react';
import { Controller, RegisterOptions, useWatch } from 'react-hook-form';
import { formatSpacedNumber } from '../../../../../../../../utils/format';
import { DebtFormGroupData } from '../../../../../FormData.dk.types';
import { outstandingAmountFieldOptions } from '../../config';

export const OutstandingAmountField = ({ index }: { index: number }) => {
  const { t } = useTranslation();

  const source = useWatch({ name: `LoanApplication/Debts.${index}.Source` });

  const registerOptions: RegisterOptions = useMemo(
    () => ({
      ...outstandingAmountFieldOptions.registerOptions,
      deps: `LoanApplication/Debts.${index}.MonthlyDebtPayment`,
      validate: (value, form) => {
        if (isNaN(value)) return t('error.required');

        const outstandingAmount = Number(value);
        const monthlyDebtPayment = Number(
          form['LoanApplication/Debts']?.[index]?.MonthlyDebtPayment
        );
        if (outstandingAmount < monthlyDebtPayment) {
          return t('Debt.OutstandingAmount.error.amount');
        }
      },
    }),
    [index, t]
  );

  return (
    <Controller
      name={`LoanApplication/Debts.${index}.OutstandingAmount`}
      render={({
        field: { name, value },
        fieldState: { error, invalid, isTouched },
      }) => (
        <NumberFieldUI<DebtFormGroupData>
          name={name}
          label={t('Debt.OutstandingAmount.label')}
          data-testid={`debt-${index}-outstanding-amount`}
          error={error}
          format={formatSpacedNumber}
          suffix={t('suffix.currency')}
          valid={!!value && !invalid && isTouched}
          disabled={source && !!value}
          aria-disabled={source && !!value}
          {...outstandingAmountFieldOptions}
          registerOptions={registerOptions}
        />
      )}
    />
  );
};
